import { fetchApi } from '@/config/api'
import type {Categorie, CategorieNode, CategorieWithLabel} from '@/types/categorie'

// Re-export des types pour la rétrocompatibilité
export type { Categorie, CategorieWithLabel }

/**
 * Récupérer toutes les catégories
 */
export async function getAllCategories(): Promise<Categorie[]> {
    const query = `
    query {
      categories {
        id_categorie
        main
        id_parent_categorie
        masque
        supprimer
      }
    }
  `

    const response = await fetchApi<{ categories: Categorie[] }>(query)
    return response.categories
}

/**
 * Récupérer les catégories principales (niveau 2, pour les lookbooks)
 * Version simplifiée avec catégories hardcodées basées sur l'ancien système
 */
// export async function getMainCategories(): Promise<CategorieWithLabel[]> {
//   // Catégories principales de l'ancien système (extraites de categories.fr.json)
//   return [
//     { id_categorie: 11, libelle: 'Femme' },
//     { id_categorie: 12, libelle: 'Homme' },
//     { id_categorie: 13, libelle: 'Enfant & Bébé' },
//     { id_categorie: 14, libelle: 'Chaussures' },
//     { id_categorie: 15, libelle: 'Maroquinerie' },
//     { id_categorie: 16, libelle: 'Accessoires' },
//     { id_categorie: 17, libelle: 'Cosmétiques' },
//     { id_categorie: 19, libelle: 'Lifestyle' },
//     { id_categorie: 20, libelle: 'Maison' }
//   ]
// }

export async function getCategoriesTree(lang: 'fr' | 'en' = 'fr'): Promise<CategorieNode[]> {
    const query = `
    query CategoriesTree($lang: String) {
      categoriesTree(lang: $lang) {
        id_categorie
        label
        id_parent_categorie
        id_top_categorie
        children {
          id_categorie
          label
          id_parent_categorie
          id_top_categorie
          children {
            id_categorie
            label
            id_parent_categorie
            id_top_categorie
          }
        }
      }
    }
  `

    const res = await fetchApi<{ categoriesTree: CategorieNode[] }>(query, { lang })
    return res.categoriesTree
}

/**
 * get top category
 */
export async function getMainCategories(): Promise<CategorieWithLabel[]> {
    const tree = await getCategoriesTree('fr')

    // top
    return tree.map(cat => ({
        id_categorie: cat.id_categorie,
        libelle: cat.label,
    }))
}
